import { useAppConfigs } from '@config/config.hooks';
import { useEffect } from 'react';
import {
  useNavigate as useNavigateFromRouter,
  generatePath,
  useParams,
  NavigateOptions,
  createSearchParams,
} from 'react-router-dom';

export const useNavigate = () => {
  const appConfigs = useAppConfigs();

  const navigateRouter = useNavigateFromRouter();

  const { projectNo: projectNoFromUrl } = useParams();

  const generateRoutePath = (path: string, params: { [key: string]: any } = {}, addProjectNo = true) => {
    if (addProjectNo) return generatePath(path, { ...params, projectNo: appConfigs.configs.project?.projectNo ?? '' });
    return generatePath(path, params);
  };

  const navigate = (
    path: string,
    params: { [key: string]: any } = {},
    addProjectNo = true,
    options: NavigateOptions | undefined = undefined,
    searchQuery: { [key: string]: any } | undefined = undefined,
  ) => {
    const pathLocal = generateRoutePath(path, params, addProjectNo);
    navigateRouter(
      { pathname: pathLocal, search: searchQuery ? `?${createSearchParams(searchQuery)}` : undefined },
      options,
    );
  };

  useEffect(() => {
    if (appConfigs.updateConfigs && typeof appConfigs.updateConfigs === 'function') {
      appConfigs.updateConfigs((configs) => {
        return { ...configs, projectNoFromUrl };
      });
    }
  }, [projectNoFromUrl]);

  return {
    navigate,
    generateRoutePath,
    projectNoFromUrl,
    projectNoFromAppConfigs: appConfigs.configs.project?.projectNo,
    projectNo: appConfigs.configs.project?.projectNo ?? projectNoFromUrl,
  };
};
